import {request,newVue,requestMsg} from "./request";
export {newVue}

export function getOrderBySearch(orderId,payNum,pageNum,pageSize) {
  return request({
    url: '/order/getOrderBySearch',
    params: {
      orderId: orderId,
      payNum: payNum,
      pageNum: pageNum,
      pageSize: pageSize
    }
  })
}

export function getOrderById(orderId) {
  return request({
    url: '/order/getOrderById',
    params: {
      id:orderId
    }
  })
}

export function checkOrderState(orderId) {
  return requestMsg({
    url: '/order/checkOrderState',
    params: {
      id:orderId
    }
  })
}

export function getOrderByState(state,pageNum,pageSize) {
  return requestMsg({
    url: '/order/getOrderByState',
    params: {
      state: state,
      pageNum: pageNum,
      pageSize: pageSize
    }
  })
}

export function invalidOrder(orderId) {
  return requestMsg({
    url: '/order/invalidOrder',
    params: {
      id:orderId
    }
  })
}

export function refundOrder(orderId) {
  return requestMsg({
    url: '/pay/refundOrder',
    params: {
      id:orderId
    }
  })
}

export function unRefundOrder(orderId) {
  return requestMsg({
    url: '/pay/unRefundOrder',
    params: {
      id:orderId
    }
  })
}

export function logisticsCode(orderId,logisticsCode,selectLogistics) {
  return requestMsg({
    url: '/order/logisticsCode',
    params: {
      orderId: orderId,
      logisticsCode: logisticsCode,
      logistics:selectLogistics
    }
  })
}

export function unOrderState(orderId,state) {
  return requestMsg({
    url: '/pay/unOrderState',
    params: {
      id:orderId,
      state: state
    }
  })
}

// export class Goods {
//   constructor(itemInfo,columns,services) {
//     this.title = itemInfo.title;
//     this.desc = itemInfo.desc;
//     this.newPrice = itemInfo.price;
//     this.oldPrice = itemInfo.oldPrice;
//     this.discount = itemInfo.discountDesc;
//     this.columns = columns;
//     this.services = services;
//     this.realPrice = itemInfo.lowNowPrice;
//   }
// }
